
export const languages = [
    { code: 'fr', name: 'Français', flag: '🇫🇷', description: 'Langue principale' },
    { code: 'en', name: 'English', flag: '🇬🇧', description: 'International' },
    { code: 'sw', name: 'Kiswahili', flag: '🇰🇪', description: "Afrique de l'Est" },
    { code: 'wo', name: 'Wolof', flag: '🇸🇳', description: 'Sénégal' },
    { code: 'ar', name: 'العربية', flag: '🇲🇦', description: 'Afrique du Nord' },
    { code: 'pt', name: 'Português', flag: '🇦🇴', description: 'Afrique lusophone' }
  ];

  // Données pour les fonctionnalités communautaires
  export const nearbyDeliverers = [
    {
      id: '1',
      name: 'Aminata K.',
      type: 'Voisin',
      distance: '200m',
      rating: 4.9,
      price: '500 GNF',
      availability: 'Disponible maintenant',
      route: 'Se rend au marché de Cocody'
    },
    {
      id: '2',
      name: 'Jean-Baptiste M.',
      type: 'Livreur Pro',
      distance: '500m',
      rating: 4.8,
      price: '1,500 GNF',
      availability: 'Disponible dans 15 min',
      route: 'Zone Plateau-Marcory'
    },
    {
      id: '3',
      name: 'Fatou D.',
      type: 'Voisin',
      distance: '300m',
      rating: 5.0,
      price: '750 GNF',
      availability: 'Disponible maintenant',
      route: 'Direction université'
    }
  ];

  // Langues supportées
  export const supportedLanguages = [
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'sw', name: 'Kiswahili', flag: '🇰🇪' },
    { code: 'wo', name: 'Wolof', flag: '🇸🇳' },
    { code: 'ar', name: 'العربية', flag: '🇲🇦' },
    { code: 'pt', name: 'Português', flag: '🇦🇴' }
  ];

  // Solutions Mobile Money
  export const mobileMoneyProviders = [
    { id: 'orange', name: 'Orange Money', icon: 'ri-smartphone-line', color: 'bg-orange-500', countries: ['CI', 'SN', 'ML', 'BF'] },
    { id: 'mtn', name: 'MTN Money', icon: 'ri-smartphone-line', color: 'bg-yellow-500', countries: ['CI', 'GH', 'UG', 'RW'] },
    { id: 'moov', name: 'Moov Money', icon: 'ri-smartphone-line', color: 'bg-blue-500', countries: ['CI', 'BF', 'TG', 'BJ'] },
    { id: 'mpesa', name: 'M-Pesa', icon: 'ri-smartphone-line', color: 'bg-green-500', countries: ['KE', 'TZ', 'UG', 'RW'] },
    { id: 'airtel', name: 'Airtel Money', icon: 'ri-smartphone-line', color: 'bg-red-500', countries: ['KE', 'UG', 'TZ', 'ZM'] }
  ];
